export const css = {
    root: '_4WPaz-DY',
    tabTitle: '_1AbarXbv',
    title: '_34Jk8LS1',
    titleClosed: 'sYITmnuo',
    titleOpen: '_20IPRXmR',
    bookIcon: '_1YBT2LxL',
    lockIcon: 'jz6dwSd7',
    ' _key': 'apic-theme/apic/explore-view/content-order'
};
export default css;
